import { type ResolvedContextData } from '@common/defaults/ContextData';
import { ViewsIcon } from '@common/svg/icons/components/ViewsIcon';
import { WidgetType } from '@common/types/Sidebar';
import { getT, Ns } from '@web/i18n';
import { NewsBlockList } from '@web/molecules/NewsBlockItem/molecules/NewsBlockListItem/NewsBlockList';
import { NewsBlockListItem } from '@web/molecules/NewsBlockItem/molecules/NewsBlockListItem/NewsBlockListItem';
import { type NewsBlockListItemProps } from '@web/molecules/NewsBlockItem/molecules/NewsBlockListItem/types';
import { SimpleWidget } from '@web/organisms/SimpleWidget';
import { type SimpleWidgetConfig } from '@web/organisms/SimpleWidget/SimpleWidget.types';

import { getMostReadThemeConfig } from './MostRead.config';

interface Props {
    contextData: ResolvedContextData;
    dataList?: NewsBlockListItemProps[];
    isTabbedWidget?: boolean;
}

export const widgetConfig: SimpleWidgetConfig = {
    title: 'most-read.title',
    type: WidgetType.MOST_READ,
};

export const Widget = ({ contextData, dataList, isTabbedWidget }: Props) => {
    const __sidebar = getT(contextData.context.locale, Ns.Sidebar);
    const title = __sidebar(widgetConfig.title);
    const metaSuffix = __sidebar('most-read.count');
    const themeConfig = getMostReadThemeConfig(contextData);
    const hasListItemUnderThreshold = dataList?.some(
        (listItem) => listItem.fullCount && listItem.fullCount < themeConfig.metaDataViewsThreshold,
    );
    return (
        <SimpleWidget contextData={contextData} title={title} isTabbedWidget={isTabbedWidget}>
            <NewsBlockList>
                {dataList?.map((data, i) => (
                    <NewsBlockListItem
                        key={i}
                        contextData={contextData}
                        metaSuffix={metaSuffix}
                        metaIcon={<ViewsIcon />}
                        isMetaHidden={hasListItemUnderThreshold}
                        {...data}
                    />
                ))}
            </NewsBlockList>
        </SimpleWidget>
    );
};
